import React, { useContext, useEffect, useState } from "react";
import {
  Alert,
  Col,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { Btn, H3 } from "../../AbstractElements";
import { Cancel, Save, Selectdefault } from "../../Shared/Constants";
import { useForm } from "react-hook-form";
import InputError from "../../Shared/Components/Form/InputError";
import EntityContext from "./ContextProvider";
import { togleLoading } from "../../Shared/Utils/alertLoading";
import InputUrl from "../../Shared/Components/Form/Inputs/InputWebSiteUrl";
import InputWebSiteUrl from "../../Shared/Components/Form/Inputs/InputWebSiteUrl";
import InputFacebook from "../../Shared/Components/Form/Inputs/InputFacebook";
import InputInstagramUrl from "../../Shared/Components/Form/Inputs/InputInstagramUrl";
import InputInstagramUsername from "../../Shared/Components/Form/Inputs/InputInstagramUsername";
import InputTwitterUrl from "../../Shared/Components/Form/Inputs/InputTwitterUrl";
import InputTwitterUsername from "../../Shared/Components/Form/Inputs/InputTwitterUsername";
import InputLinkedin from "../../Shared/Components/Form/Inputs/InputLinkedin";
import InputPhone from "../../Shared/Components/Form/Inputs/InputPhone";
import CustomSelect from "../../Shared/Components/Form/CustomSelect";
import { getProvincesApi } from "../../Shared/Api/GetProvinces";
import { getCitiesApi } from "../../Shared/Api/GetCities";
import { SUCCESS_API_RESPONSE } from "../../Shared/Constants/api";

export default function EntityForm() {
  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [provinceId, setProvinceId] = useState([]);

  //context
  const { createItem, apiErrors, modalTogle, modal, item, updateItem, saving } =
    useContext(EntityContext);
  //form
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors, isDirty },
  } = useForm();

  const onSubmit = (data) => {
    if (item && item?.id) {
      updateItem(data, item?.id);
    } else {
      createItem(data);
    }
  };

  //set default values to form
  useEffect(() => {
    reset({
      name: item?.name,
      type: item?.type,
    });
    setValue("facebook_url", item?.facebook_url);
    setValue("linkedin_url", item?.linkedin_url);
    setValue("instagram_url", item?.instagram_url);
    setValue("website_url", item?.website_url);
    setValue("instagram_username", item?.instagram_username);
    setValue("twitter_url", item?.twitter_url);
    setValue("twitter_username", item?.twitter_username);
    setValue("whatsapp", item?.whatsapp);
    setValue("city_id", item?.city_id);
  }, [item]);

  //alert
  const [alertOpen, setAlertOpen] = useState(
    apiErrors && apiErrors.length > 0 ? true : false
  );

  useEffect(() => {
    fetchProvinces();
  }, []);
  //usefect
  useEffect(() => {
    setAlertOpen(apiErrors && apiErrors.length > 0 ? true : false);
  }, [apiErrors]);

  useEffect(() => {
    togleLoading(saving);
  }, [saving]);

  const fetchProvinces = async () => {
    let response = await getProvincesApi();
    if (response.result === SUCCESS_API_RESPONSE) {
      setProvinces(response.data?.items);
    }
  };

  const fetchCities = async () => {
    if (provinceId) {
      let response = await getCitiesApi({ province_id: provinceId });
      if (response.result === SUCCESS_API_RESPONSE) {
        setCities(response.data?.items);
      }
    }
  };

  const handleChangeProvince = async (e) => {
    setProvinceId(e?.id);
  };

  useEffect(() => {
    setValue("province_id", item?.city?.province_id);

    fetchCities();
  }, [provinceId]);

  useEffect(() => {
    console.log("item?.city?.province_id", item?.city?.province_id);

    setValue("province_id", item?.city?.province_id);
    setProvinceId(item?.city?.province_id);
  }, [provinces]);

  return (
    <Form onSubmit={handleSubmit(onSubmit)} id="entitiesForm">
      <Modal isOpen={modal} toggle={modalTogle} className="rounded-1" size="lg">
        <ModalHeader toggle={modalTogle}>
          <div>
            <H3
              attrH3={{
                className: "modal-title",
                id: "exampleModalLabel1",
              }}
            >
              {item?.id ? "Modificar Entidad" : "Agregar Entidad"}
            </H3>
          </div>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col sm="6">
              <FormGroup className="mb-3 col-md-12">
                <Label htmlFor="name" className="form-label">
                  Nombre
                </Label>
                <input
                  className="form-control"
                  type="text"
                  required=""
                  placeholder="Ingresa el nombre de la entidad"
                  autoComplete="off"
                  {...register("name", {
                    required: "El nombre es obligatorio",
                  })}
                />
                <InputError errors={errors} name="name" />
              </FormGroup>
            </Col>{" "}
            <Col sm="6">
              <FormGroup>
                <Label htmlFor="type" className="form-label">
                  Tipo
                </Label>
                <select
                  id="type"
                  className={`form-select ${errors.brand && "is-invalid"}`}
                  name="brand"
                  {...register("type", { required: "El tipo es obligatorio" })}
                >
                  <option value={""}>{Selectdefault}</option>
                  <option>MEDIOS</option>
                </select>
                <InputError errors={errors} name="type" />
              </FormGroup>
            </Col>
            <Col sm="6">
              <FormGroup className="mb-3 col-md-12">
                <Label htmlFor="name" className="form-label">
                  Web site url
                </Label>
                <InputWebSiteUrl
                  errors={errors}
                  register={register}
                ></InputWebSiteUrl>
                <InputError errors={errors} name="name" />
              </FormGroup>
            </Col>
            <Col sm="6">
              <FormGroup className="mb-3 col-md-12">
                <Label htmlFor="linkedin_url" className="form-label">
                  Linkedin url
                </Label>
                <InputLinkedin
                  errors={errors}
                  register={register}
                ></InputLinkedin>
                <InputError errors={errors} name="linkedin_url" />
              </FormGroup>
            </Col>
            <Col sm="6">
              <FormGroup className="mb-3 col-md-12">
                <Label htmlFor="facebook_url" className="form-label">
                  Facebook url
                </Label>
                <InputFacebook
                  errors={errors}
                  register={register}
                ></InputFacebook>
                <InputError errors={errors} name="facebook_url" />
              </FormGroup>
            </Col>
            <Col sm="6">
              <FormGroup className="mb-3 col-md-12">
                <Label htmlFor="instagram_url" className="form-label">
                  Instagram url
                </Label>
                <InputInstagramUrl
                  errors={errors}
                  register={register}
                ></InputInstagramUrl>
                <InputError errors={errors} name="instagram_url" />
              </FormGroup>
            </Col>
            <Col sm="6">
              <FormGroup className="mb-3 col-md-12">
                <Label htmlFor="instagram_username" className="form-label">
                  Instagram username
                </Label>
                <InputInstagramUsername
                  errors={errors}
                  register={register}
                ></InputInstagramUsername>
                <InputError errors={errors} name="instagram_username" />
              </FormGroup>
            </Col>
            <Col sm="6">
              <FormGroup className="mb-3 col-md-12">
                <Label htmlFor="twitter_url" className="form-label">
                  Twitter url
                </Label>
                <InputTwitterUrl
                  errors={errors}
                  register={register}
                ></InputTwitterUrl>
                <InputError errors={errors} name="twitter_url" />
              </FormGroup>
            </Col>
            <Col sm="6">
              <FormGroup className="mb-3 col-md-12">
                <Label htmlFor="twitter_username" className="form-label">
                  Twitter username
                </Label>
                <InputTwitterUsername
                  errors={errors}
                  register={register}
                ></InputTwitterUsername>
                <InputError errors={errors} name="twitter_username" />
              </FormGroup>
            </Col>
            <Col sm="6">
              <FormGroup className="mb-3 col-md-12">
                <Label htmlFor="whatsapp" className="form-label">
                  Whatsapp
                </Label>
                <InputPhone
                  errors={errors}
                  register={register}
                  name={"whatsapp"}
                ></InputPhone>
                <InputError errors={errors} name="whatsapp" />
              </FormGroup>
            </Col>
            <Col sm="6">
              <FormGroup>
                <Label htmlFor="type" className="form-label">
                  Provincia
                </Label>
                <CustomSelect
                  items={provinces}
                  name={"province_id"}
                  setValue={setValue}
                  placeholder="Seleccione"
                  errors={errors}
                  register={register}
                  item={item.city}
                  customChangeHandler={handleChangeProvince}
                />
                <InputError errors={errors} name="type" />
              </FormGroup>
            </Col>
            <Col sm="6">
              <FormGroup>
                <Label htmlFor="type" className="form-label">
                  Ciudad
                </Label>
                <CustomSelect
                  items={cities}
                  name={"city_id"}
                  setValue={setValue}
                  placeholder="Seleccione"
                  errors={errors}
                  register={register}
                  item={item}
                />
                <InputError errors={errors} name="type" />
              </FormGroup>
            </Col>
          </Row>
          <Btn
            attrBtn={{
              color: "secondary",
              className: "ms-1",
              onClick: modalTogle,
            }}
          >
            {Cancel}
          </Btn>
          <Btn
            attrBtn={{
              type: "submit",
              form: "entitiesForm",
              className: "ms-1",
              color: `${isDirty ? "primary" : "secondary"}`,
              disabled: !isDirty,
            }}
          >
            {Save}
          </Btn>
        </ModalBody>
      </Modal>
    </Form>
  );
}
